export const base_url = process.env.REACT_APP_URL;
export const s3_bucket_url = process.env.REACT_APP_S3_BUCKET_URL;
export const api_base_url = process.env.REACT_APP_API_URL;
